import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService, SaleOrdersService } from '@services';

@Component({
  selector: 'digicem-preview-photo-dialog',
  templateUrl: './preview-photo-dialog.component.html',
})
export class PreviewPhotoDialogComponent implements OnDestroy {
  protected previewFile: File;
  protected saleOrderId: string;
  protected isLoading = false;
  protected previewUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      previewFile: File;
      saleOrderId: string;
    },
    private dialogRef: MatDialogRef<PreviewPhotoDialogComponent>,
    private saleOrdersService: SaleOrdersService,
    private alertService: AlertService,
  ) {
    this.previewFile = data.previewFile;
    this.saleOrderId = data.saleOrderId;
    this.previewUrl = URL.createObjectURL(data.previewFile);
  }

  ngOnDestroy(): void {
    URL.revokeObjectURL(this.previewUrl);
  }

  protected onConfirmDelivery(): void {
    if (!this.isLoading) {
      this.isLoading = true;
      this.saleOrdersService
        .patchDeliveryPhoto(this.saleOrderId, this.previewFile)
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.dialogRef.close('confirm');
          },
          error: () => {
            this.isLoading = false;
            this.alertService.showAlert(
              'Error al enviar la foto de entrega. Por favor, inténtelo de nuevo.',
              'critical',
              60,
            );
          },
        });
    }
  }

  protected onTakeOtherPhoto(): void {
    this.dialogRef.close('take_other_photo');
  }
}
